import React from 'react';
import { Users, Heart, Building2, Briefcase, Shield, Clock, Truck } from 'lucide-react';

const Customers = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }}>
            <h1 className="hero-large" style={{ marginBottom: '24px' }}>
              Trusted by Families, Doctors & Institutions
            </h1>
            <p className="body-large" style={{
              color: 'var(--text-secondary)',
              marginBottom: '32px'
            }}>
              Transparent pricing with flat 20% medicine discount, wide availability, and home delivery with digital receipts.
            </p>
          </div>
        </div>
      </section>

      {/* Customer Segments */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '40px'
          }}>
            <div className="hover-lift" style={{
              padding: '40px',
              background: 'var(--bg-primary)',
              borderRadius: '0px'
            }}>
              <Users size={40} style={{ color: 'var(--brand-blue)', marginBottom: '16px' }} />
              <h3 className="heading-2" style={{ marginBottom: '12px' }}>
                Families
              </h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)', marginBottom: '16px' }}>
                Consistent savings on everyday healthcare needs with professional pharmacist guidance.
              </p>
              <ul style={{
                listStyle: 'none',
                padding: 0,
                margin: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: '8px'
              }}>
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• 20% flat discount on all medicines</li>
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Wide range of OTC and wellness products</li>
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Home delivery for convenience</li>
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Digital prescription management</li>
              </ul>
            </div>

            <div className="hover-lift" style={{
              padding: '40px',
              background: 'var(--bg-primary)',
              borderRadius: '0px'
            }}>
              <Heart size={40} style={{ color: 'var(--brand-green)', marginBottom: '16px' }} />
              <h3 className="heading-2" style={{ marginBottom: '12px' }}>
                Chronic Care Patients
              </h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)', marginBottom: '16px' }}>
                Easy refills, medication reminders, and assured availability of specialty medicines.
              </p>
              <ul style={{
                listStyle: 'none',
                padding: 0,
                margin: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: '8px'
              }}>
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Specialty & imported medicines in stock</li>
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Insulin and diabetes care at discount</li>
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Automated refill reminders</li>
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Consistent pricing and availability</li>
              </ul>
            </div>

            <div className="hover-lift" style={{
              padding: '40px',
              background: 'var(--bg-primary)',
              borderRadius: '0px'
            }}>
              <Building2 size={40} style={{ color: 'var(--brand-blue)', marginBottom: '16px' }} />
              <h3 className="heading-2" style={{ marginBottom: '12px' }}>
                Clinics & Hospitals
              </h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)', marginBottom: '16px' }}>
                Assured medicine supply with bulk pricing for healthcare institutions.
              </p>
              <ul style={{
                listStyle: 'none',
                padding: 0,
                margin: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: '8px'
              }}>
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• B2B pricing through One Deal</li>
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Reliable and timely supply</li>
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Credit facilities available</li>
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Dedicated account management</li>
              </ul>
            </div>

            <div className="hover-lift" style={{
              padding: '40px',
              background: 'var(--bg-primary)',
              borderRadius: '0px'
            }}>
              <Briefcase size={40} style={{ color: 'var(--brand-green)', marginBottom: '16px' }} />
              <h3 className="heading-2" style={{ marginBottom: '12px' }}>
                Corporate & NGOs
              </h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)', marginBottom: '16px' }}>
                Workplace wellness programs and medicine procurement support.
              </p>
              <ul style={{
                listStyle: 'none',
                padding: 0,
                margin: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: '8px'
              }}>
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Employee wellness tie-ups</li>
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Bulk procurement services</li>
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Health camp support</li>
                <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Customized billing and reports</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Premium Experience */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <h2 className="hero-medium" style={{ marginBottom: '60px', textAlign: 'center' }}>
            The Care Pharmacy Experience
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '40px'
          }}>
            <div style={{ textAlign: 'center' }}>
              <Shield size={40} style={{ color: 'var(--brand-blue)', marginBottom: '16px', display: 'inline-block' }} />
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>
                Genuine Products
              </h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                All medicines sourced directly from authorized distributors and manufacturers.
              </p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <Users size={40} style={{ color: 'var(--brand-green)', marginBottom: '16px', display: 'inline-block' }} />
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>
                Courteous Staff
              </h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Trained pharmacists and staff providing professional, empathetic service.
              </p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <Clock size={40} style={{ color: 'var(--brand-blue)', marginBottom: '16px', display: 'inline-block' }} />
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>
                Convenient Hours
              </h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Extended operating hours at most locations for your convenience.
              </p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <Truck size={40} style={{ color: 'var(--brand-green)', marginBottom: '16px', display: 'inline-block' }} />
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>
                Fast Delivery
              </h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Order via phone or WhatsApp and receive doorstep delivery with digital receipts.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Store Standards */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <div style={{
            maxWidth: '800px',
            margin: '0 auto',
            textAlign: 'center'
          }}>
            <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
              Premium Store Standards
            </h2>
            <p className="body-large" style={{
              color: 'var(--text-secondary)',
              marginBottom: '48px'
            }}>
              Every Care Pharmacy store maintains the highest standards of cleanliness, organization, and customer service.
            </p>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap: '32px',
              textAlign: 'left'
            }}>
              {[
                'Clean and organized shelves',
                'Temperature-controlled storage',
                'Well-lit, spacious interiors',
                'Digital billing systems',
                'Privacy-conscious consultation',
                'Accessible layouts',
                'Professional uniforms',
                'Regular quality audits'
              ].map((standard, index) => (
                <div key={index} style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '12px',
                  padding: '16px',
                  background: 'var(--bg-primary)',
                  borderRadius: '0px'
                }}>
                  <div style={{
                    width: '6px',
                    height: '6px',
                    background: 'var(--brand-green)',
                    borderRadius: '50%',
                    marginTop: '8px',
                    flexShrink: 0
                  }} />
                  <span className="body-regular">{standard}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-padding-small" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <div style={{
            maxWidth: '700px',
            margin: '0 auto',
            textAlign: 'center'
          }}>
            <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
              Experience Care Pharmacy Today
            </h2>
            <p className="body-large" style={{
              color: 'var(--text-secondary)',
              marginBottom: '32px'
            }}>
              Visit your nearest store or order online for doorstep delivery.
            </p>
            <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <a href="/stores" className="btn-primary">
                Find a Store
              </a>
              <a href="tel:+916358585323" className="btn-secondary">
                Call for Home Delivery
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Customers;